import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAgeRange,
  selectAgeRange,
  setDataSuccess
} from 'src/features/staticDataSlice';
import AgeCreateModal from 'src/pages/AgeSettings/AgeCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function AgeRangemasterList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [ageCreatePermission, setAgeCreatePermission] = useState(false);

  const ageRangeData = useSelector(selectAgeRange);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setAgeCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('ageRange', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchAgeRange(productId).then((data) =>
      dispatch(setDataSuccess({ dataType: 'ageRange', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation logic if required

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-ageRange" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-ageRange"
          id="select-ageRange"
          value={tableListDatas[index]?.ageRange || ''}
          onChange={(event) => {
            handleChange('ageRange', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 160 }}
          error={error}
        >
          {ageRangeData?.map((age) => (
            <MenuItem key={age.ageName} value={age?.ageName}>
              {age?.ageName}
            </MenuItem>
          ))}
          <Tooltip
            title={
              ageCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Age Range
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (ageCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: ageCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <AgeCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default AgeRangemasterList;
